import * as React from 'react';
import Box from '../../../parts/Box';

import {IAnalysisOfCorrelatedPositionsData, IAnalysisOfCorrelatedPositionsFunctions} from '../props/IAnalysisOfCorrelatedPositionsComponentProps';


import { Container, Col, Row,  Form, Label } from 'reactstrap';
import HelpTooltip from '../../../commons/HelpTooltip';


type IProps = IAnalysisOfCorrelatedPositionsData & IAnalysisOfCorrelatedPositionsFunctions;


// InputComponent state is used to be provided as the context for child components


export default class analysisOfCorrelatedPositions extends React.Component< IProps> {

    infoRef = React.createRef<HTMLFormElement>();
/*---------------------------------------------------------------------------------------------------------------------------------- */
    render() {

        return  <div>
                    <Box title = "ANALYSIS OF CORRELATED POSITIONS">                       
                    <Form>
                            <Container>
                                <Row >
                
                                    <Col>       
                                        <Row>       
                                        <Col>
                                        <Label htmlFor="minIdentityFieldSP" style = {{color: "#09A0A8", paddingLeft: "4px"}} >
                                            Z-score threshold:
                                                    <HelpTooltip>
                                                    Each two protein positions which have the average z-score greater 
                                                    than or equal to the specified threshold will be assigned 
                                                    as correlated positions. Average z-score is calculated from 
                                                    the results of all tools that returned a valid score. The 
                                                    full set of tools for the prediction of correlated positions 
                                                    involves: ELSC, FreeContact (DCA), McBASC, MI, aMIc, OMES and SCA.
                                                    </HelpTooltip> 
                                                </Label>
                                        </Col>                    
                                        <form id="ll-input-info" ref={this.infoRef}>
                                            <div className="form-group">
                                                
                                                <input type="text" className="form-control" id="z_score_threshold"
                                                    style = {{width: "75px" , height: "30px"}}
                                                    value={this.props.zScoreThreshold}
                                                    onChange={evt => this.props.changeZScoreThreshold(evt.target.value)}
                                                    required
                                                />
                                            </div>
                                        </form>
                                        </Row>      
                                           
                                    </Col>
                                </Row>
                            </Container>
                        </Form>
                    </Box>
                    </div>
}}
